<div [hidden]="!ladda" [ngClass]="customClass" class="travel-spinner" role="alert" aria-live="polite">
    <div class="loading-spinner">
        <span class="sr-only" translate>Loading</span>
        <img aria-hidden="true" alt="" src="../../assets/images/spinner-hsbc.svg"/>
    </div>
</div>
